import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useLangstonMediaGet = (contentId) => {
  const requestUrl = `${API_BASE_URL}/api/v3/content-document/${contentId}/media/`;
  return useRestQuery(requestUrl, { skip: !contentId });
};

export default useLangstonMediaGet;
